import { useState } from 'react'
import { FiAlertCircle } from 'react-icons/fi'
import { Form, Formik } from 'formik'

import { Modal } from 'Components/Ui'
import { Button } from 'Components/Form'

export default function ConfirmationModal({
    children,
    data,
    validation,
    onConfirm,
    title = '',
    message = '',
    className = '',
    icon = <FiAlertCircle size={40} />,
    ariaLabel,
    maxWidth = 'md',
    form,
    modelOpen,
    modalClose = true,
}) {
    const [confirming, setConfirming] = useState(false)

    const closeModal = () => setConfirming(false)
    const handleOpen = () => {
        Promise.resolve()
            .then(() => modelOpen && modelOpen())
            .catch(() => {})
            .finally(() => setConfirming(true))
    }

    const submit = (values, { setSubmitting }) => {
        setSubmitting(true)
        Promise.resolve(onConfirm(values, closeModal)).finally(() => {
            setSubmitting(false)
            modalClose && closeModal()
        })
    }

    return (
        <div>
            <button type="button" aria-label={ariaLabel} className={className} onClick={handleOpen}>
                {children}
            </button>
            <Modal show={confirming} onClose={closeModal} maxWidth={maxWidth}>
                <Formik initialValues={data ?? {}} validationSchema={validation} onSubmit={submit}>
                    {({ values, touched, errors, isSubmitting, setFieldValue }) => (
                        <Form className="grid gap-3 p-6 text-center">
                            {icon && (
                                <span className="inline-block mx-auto">
                                    <div className="flex items-center justify-center w-20 h-20 transition rounded-full bg-warning/10 text-warning">
                                        {icon}
                                    </div>
                                </span>
                            )}
                            <h3 className="text-xl font-bold text-black dark:text-white sm:text-2xl">
                                {title || 'Confirmation Alert!'}
                            </h3>
                            <p className="text-sm">{message || 'Are you sure you want to change status?'}</p>
                            {form && form(touched, errors, values, setFieldValue, closeModal)}
                            <div className="grid grid-cols-1 gap-3 pt-5 md:grid-cols-2">
                                <Button type="button" className="w-full text-white border-danger bg-danger" onClick={closeModal}>
                                    No
                                </Button>
                                <Button
                                    className="w-full text-white border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                    disabled={isSubmitting}
                                    type="submit"
                                >
                                    Yes
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal>
        </div>
    )
}
